function getPathTemplate(key = '') {
    let URL = ''
    key = key.toUpperCase()
    switch(key) {
        case 'HOME':
            URL = '/FAQ/{gameName}/{page}/{alias}/{key}'
            break;
        case 'LIST':
            URL = '/FAQ/List/{gameName}'
            break;
    }
    return URL
}

export function getBreadcrumbPath(paths, pageInfo) {
    return paths.map(item => {
        let {
            key,
            label,
        } = item
        let itemPath = getPathTemplate(key)
        let reg = /\{(.*?)\}/g
        let url = itemPath.replace(reg, (match, p) => {
            return pageInfo[p]
        })
        return {
            label,
            path: url,
        }
    })
}

export function dealShowPath(url) {
    if (typeof url !== 'string') return '/'
    url = url.replace(/\s/g, '-')
    return url.replace(/\//g, '')
}